import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import ShortInfo from 'src/components/user/ShortInfo';
import PopupSelect from 'src/components/complex/popupSelect';
import { MCButton, MCText, View } from 'src/components/basic';
import { lang, remCss, upperFirstCharAll } from 'src/helpers';

import { STEPS } from './constants';
import LANG_CONST from 'src/helpers/lang/const';
import { FormRow } from 'components/Form';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

export class Patient extends BaseComponent {
  get model() {
    return this.props.model;
  }

  get config() {
    return this.props.config;
  }

  componentDidMount() {
    this.model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.model.unsubscribe(this.subscription);
  }

  next = async (e) => {
    e.preventDefault();
    if (!this.model.state.patientId) {
      this.model.setInvalidApi(this.model.state.saveApi, {
        length: 1,
        patient: 'Patient is required.'
      });
    } else {
      this.props.loadBeforeSlotStep({ id: this.model.state.patientId }).then();
    }
  };

  render = () => {
    const { invalid } = this.model.getApiState(this.model.state.saveApi);
    const loading =
      this.model.getApiState('getSlots').loading || this.model.getApiState('doctorDetail').loading;

    return (
      <div
        className={
          'mc-tab-content ' + (this.model.state.step === STEPS.PATIENT ? '' : 'mc-inactive')
        }
      >
        <View style={{ flex: 1 }}>
          <FormRow>
            <PopupSelect
              template={5}
              isPopover={true}
              invalid={invalid}
              label={LANG_CONST.select_a_patient}
              placeholder={LANG_CONST.select}
              name={'patient'}
              value={this.model.state.patientId}
              initSelectedParamKey={'patientId'}
              apiConfig={{
                url: 'patient/refresh',
                labelFn: (user) => (
                  <div className={'mc-flex'} style={{ padding: remCss(2) }}>
                    <ShortInfo medium user={user} specialist={[]} width={48} />
                    <div className={'mc-label-418 mc-text-truncate'}>
                      {user.phoneNumber && formatPhoneNumberIntl(user.phoneNumber.toString())}
                    </div>
                  </div>
                ),
                searchAll: true
              }}
              selectedLabelFn={(user) => (
                <ShortInfo
                  small
                  user={user}
                  specialist={[]}
                  style={{
                    marginTop: remCss(-3),
                    marginBottom: remCss(-3),
                    cursor: 'pointer'
                  }}
                />
              )}
              onChange={(n, v) => {
                this.model.resetApiState(this.model.state.saveApi);
                this.model.setState({ patientId: v });
              }}
            />
            <div className={'mc-flex-20'} style={{ marginTop: remCss(42) }}>
              <MCText label={upperFirstCharAll(lang.t(LANG_CONST.or))} />
              <MCButton
                label={LANG_CONST.buttons.add_new_patient}
                medium
                primary
                light
                onClick={() => this.model.nextStep(STEPS.ADD_PATIENT)}
              />
            </div>
          </FormRow>
        </View>
        <div className={'mc-flex-20'}>
          {this.model.state.historySteps.length > 0 && (
            <MCButton
              light
              primary
              radius
              medium
              disabled={loading}
              onClick={(e) => {
                e.preventDefault();
                this.model.previousStep();
              }}
              label={'Previous'}
            />
          )}
          <div className={'mc-grow'} />
          <MCButton
            primary
            medium
            radius
            light
            label={LANG_CONST.buttons.cancel}
            style={{ width: remCss(100) }}
            disabled={loading}
            onClick={this.props.onBack}
          />
          <MCButton
            primary
            medium
            radius
            dark
            label={LANG_CONST.buttons.next}
            style={{ width: remCss(100) }}
            disabled={loading}
            loading={loading}
            onClick={this.next}
          />
        </div>
      </div>
    );
  };
}
